import React from 'react';
import { useAppSelector } from '../../store';
import HeadDashboard from './HeadDashboard';

/**
 * MIS Incharge uses the same dashboard shell as Head / Regional Head / PSO (HeadDashboard):
 * KPIs, branch-type tiles, request status charts, survey tables, and weekly summary —
 * scoped to the full bank/company (no managed PSO filter), which matches MIS oversight data.
 */
export default function MisInchargeDashboard() {
    const pso = useAppSelector((s) => s.user.pso);

    return (
        <HeadDashboard
            dashboardTitle="MIS Incharge dashboard"
            dashboardSubtitle={`Welcome, ${pso?.name || 'MIS Incharge'}. Company-wide branches, surveys, staff, and requests — same overview as Head and regional dashboards.`}
        />
    );
}
